// Slider setup
const slider = tns({
  container: '.slider',
  items: 1,
  slideBy: 'page',
  controls: false,
  navPosition: 'bottom'
});

// var sliderTestimonials = tns({
//   container: '.slider',
//   items: 1,
//   slideBy: 'page',
//   controls: false,
//   navContainer: '.slider__nav',
//   navItem: '.slider__nav__item',
// });

// Animation activation section

const sectionAnimation = () => {
  const sections = document.querySelectorAll('[data-animate]');  
  
  sections.forEach(section => {
    const halfWindow = window.innerHeight * 0.6;
    const isSectionVisible = (section.getBoundingClientRect().top - halfWindow) < 0;

    if(isSectionVisible) {
      section.setAttribute("data-animate", "true");
    }
  });  
}

window.addEventListener('scroll', sectionAnimation);

// Crossfade slider

function initCrossfadeSlider() {
  let current = 0;
  let images = document.querySelectorAll('[data-crossfade-image]');

  setInterval(() => {
    images.forEach((image) => (image.style.opacity = 0));
    current = current != images.length - 1 ? current + 1 : 0;
    images[current].style.opacity = 1;
  }, 5000);
}

initCrossfadeSlider();

// Parallax Animation

 ScrollTrigger.matchMedia({
	 "(min-width: 1048px)": function() {
			 let timelineCan = gsap.timeline({
				 scrollTrigger: { 
					 trigger: ".talent",
					 end: "+=800",
					 pin: true,
					 scrub: true
				 }
			 });
 
			 timelineCan.set('.talent__image-tampa', { y: -200});
			 timelineCan.to('.talent__image-tampa', { y: 0});
	 },
 })